//階段資料
export const STEP = {
	Id: null,
	RecruitPlanId: null,
	Name: null,
	NameInEnglish: null,
	StepOrder: null,
	StartTime: null,
	EndTime: null,
	Description: null,
	DescriptionInEnglish: null,
}

//階段狀態
export const STEP_STATUS = {
	Unpublished: 'Unpublished', //未鎖定
	Published: 'Published', //鎖定
}
